import React from "react";
import {
  AppShell,
  Burger,
  Group,
  NavLink,
  Text,
  Avatar,
  Menu,
  Box,
  useMantineTheme,
  Stack,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import {
  IconLogout,
  IconBuildingStore,
  IconBuildingWarehouse,
  IconLayoutDashboard,
  IconShirt,
} from "@tabler/icons-react";

export default function ShopOwnerLayout() {
  const [opened, { toggle }] = useDisclosure();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useMantineTheme();

  // Safe parsing of user data
  const userString = localStorage.getItem("shopUser");
  const user = userString ? JSON.parse(userString) : { nickname: "Owner" };

  const logout = () => {
    localStorage.removeItem("shopToken");
    localStorage.removeItem("shopUser");
    navigate("/shop-owner/login");
  };

  return (
    <AppShell
      header={{ height: 60 }}
      navbar={{
        width: 280,
        breakpoint: "sm",
        collapsed: { mobile: !opened },
      }}
      padding="md"
    >
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between">
          <Group>
            <Burger
              opened={opened}
              onClick={toggle}
              hiddenFrom="sm"
              size="sm"
            />
            <Group gap="xs">
              <IconBuildingStore size={28} color={theme.colors.blue[6]} />
              <Text fw={800} size="xl" visibleFrom="xs">
                Shop<span className="text-blue-600">Manager</span>
              </Text>
            </Group>
          </Group>

          <Menu shadow="md" width={200} position="bottom-end">
            <Menu.Target>
              <Group
                gap="xs"
                style={{ cursor: "pointer" }}
                className="hover:bg-gray-50 p-1 rounded-md transition"
              >
                <Avatar color="blue" radius="xl" size="md">
                  {user.nickname?.[0]}
                </Avatar>
                <Box visibleFrom="xs">
                  <Text size="sm" fw={600} lh={1}>
                    {user.nickname}
                  </Text>
                  <Text size="xs" c="dimmed">
                    Shop Owner
                  </Text>
                </Box>
              </Group>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Label>Account</Menu.Label>
              <Menu.Item
                color="red"
                leftSection={<IconLogout size={14} />}
                onClick={logout}
              >
                Logout
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Group>
      </AppShell.Header>

      <AppShell.Navbar p="md">
        <Stack gap="xs">
          <NavLink
            label="Dashboard"
            leftSection={<IconLayoutDashboard size={20} />}
            active={location.pathname === "/shop-owner/dashboard"}
            onClick={() => navigate("/shop-owner/dashboard")}
            color="blue"
            variant="light"
            style={{ borderRadius: 8 }}
          />
          <NavLink
            label="My Shops"
            leftSection={<IconBuildingStore size={20} />}
            active={location.pathname.includes("/shop-owner/shops")}
            onClick={() => navigate("/shop-owner/shops")}
            color="blue"
            variant="light"
            style={{ borderRadius: 8 }}
          />
          <NavLink
            label="My Products"
            leftSection={<IconShirt size={20} />}
            active={location.pathname === "/shop-owner/products"}
            onClick={() => navigate("/shop-owner/products")}
            color="blue"
            variant="light"
            style={{ borderRadius: 8 }}
          />
        </Stack>
      </AppShell.Navbar>

      <AppShell.Main bg="gray.0">
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
}
